<template>
  <div class="carrot">
    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">동영상 뉴스 관리</h3>
              <p class="lead">
                <span>-동영상 뉴스 컨텐츠를 관리하는 곳입니다. [컨텐츠 등록]버튼 클릭 후 동영상 뉴스를 등록해 주시기 바랍니다.</span><br>
                <span>-Title을 클릭하시면 상세정보를 보실 수 있습니다.</span><br>
                <span>-전화영어 토픽으로 이용하시려면 해당 뉴스를 선택하신 후 '전화영어 토픽이용' 버튼을 눌러주세요.</span><br>
                <span>-Date에서 해당월에 등록된 동영상 뉴스만 검색해서 보실 수 있습니다.</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <div class="form-group float-left clear w-100per">
                      <select v-model="filter.year" name="selYear" class="form-control fl w-15">
                        <option value="" selected>연도선택</option>
                        <option v-for="year in years" :key="year" :value="year">{{ year }}년</option>
                      </select>
                      <select v-model="filter.month" name="selMonth"
                              class="form-control fl w-15 ml-10">
                        <option value="" selected>월선택</option>
                        <option v-for="month in months" :key="month" :value="month">{{
                            month
                          }}월
                        </option>
                      </select>
                      <input v-model="filter.code" type="text" class="form-control w-20 ml-10 fl"
                             placeholder="코드명을 입력해주세요">
<!--                      <select v-model="filter.tutor" name="selMonth"
                              class="form-control fl w-15 ml-10">
                        <option value="">강사선택</option>
                        <option v-for="tutor in tutors" :key="tutor" :value="tutor.tutor_seq">
                          {{ tutor.englishname }}
                        </option>
                      </select>-->
                      <button class="btn btn-primary fl ml-10"
                              @click="selectVideos()">검색
                      </button>
                      <button class="btn btn-primary fl ml-10"
                              @click="selectVideoAll()">전체보기
                      </button>
                      <button class="btn btn-primary fr ml-10"
                              @click="goOtherPage('/videos/add')">등록
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive text-center">
                    <table class="table table-hover table-bordered">
                      <thead>
                      <tr>
                        <th>선택</th>
                        <th>로이터<br> 플랫폼<br>노출여부</th>
                        <th>전화영어 <br>Topic</th>
                        <th>글로벌존<br></br>사용</th>
                        <th>i:MOOC<br>발송일</th>
                        <th>당근농장<br>노출여부</th>
                        <th>추천<br>메일<br>발송일</th>
                        <th>No</th>
                        <th>코드명</th>
                        <th>Date</th>
                        <th>Title</th>
                        <th>Tutor</th>
                        <th>입력일</th>
                        <th>View</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :class="{ 'is-use': value.display_status === 'A', 'is-not-use': value.display_status === null }" v-for="(value) in videos" :key="value.idx">
                        <td><input class="check-topic" type="checkbox" :value="value.news_seq"></td>
                        <td style="cursor: pointer" @click="goOtherPage(`/videos/modify/`+ value.news_seq)"><span :class="{ 'is-not-use-text': value.is_nrpaltform == null, 'is-use-text': value.is_nrpaltform != null,  }">{{ (value.is_nrpaltform != null) ? '사용' : '미사용' }}</span></td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.call_topic }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.call_main }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.webzine_date }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ (value.IS_FARM === 'Y') ? value.IS_FARMDATE : '' }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.guest_webzine_date }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.news_seq }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.newsCode }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.newsdate }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.eng_title }} </td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.tutor }}</td>
                        <td style="cursor: pointer" @click="goOtherPage('/videos/modify/' + value.news_seq)">{{ value.CDATE }}</td>
                        <td>
                          <button @click="doMoveView(value.news_seq)">view</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <button class="btn btn-primary fl ml-10 mt-3" @click="updateTopic()">전화영어 토픽이용
                    </button>
                    <button class="btn btn-primary fr ml-10 mt-3" @click="goOtherPage(`/videos/add`)">등록
                    </button>
                    <button class="btn btn-primary fr ml-10 mt-3" @click="deleteNews()">삭제
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Menu from '../../components/commons/incMenu'

export default {
  name: 'Videos',
  components: {
    Menu
  },
  data () {
    return {
      tutors: [],
      videos: [],
      filter: {
        year: '',
        month: '',
        code: '',
        tutor: ''
      },
      years: [],
      months: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
      ],
      reuters: [
        {
          no: 60,
          isSelect: false,
          isPlatform: '사용',
          isTopic: 'Y',
          isMain: 'OK',
          sendImoocDate: '2021-01-25',
          sendMailDate: '2021-01-25',
          code: 'CKR130947',
          date: '2021-01-22',
          title: 'Norwegian Air gets backing for survival plan',
          tutor: 'Joanne Jang(내부 직원)',
          create_date: '2021-01-22'
        }
      ]
    }
  },
  mounted () {
    /// 캐쉬 지우기
    caches
    .keys()
    .then(c => {
      for (const i of c) {
        caches.delete(i);
      }
    })

    /// 연도선택 채우기
    const nowYear = Number(this.$moment().format('YYYY'))
    const nowMonth = Number(this.$moment().format('MM'))
    this.filter.year = nowYear
    this.filter.month = nowMonth
    const nextYear = nowMonth === 12 ? nowYear + 1 : nowYear; // 12월 인경우 + 1
    for (let i = 2010; i <= nextYear; i++) {
      this.years.push(i)
    }

    if(localStorage.getItem('reuterContentsParams') !== null){
      this.filter = JSON.parse(localStorage.getItem('reuterContentsParams'))
    }

    /// 동영상 뉴스 목록
    this.selectVideos()
    this.selectTutors()
  },
  methods: {
    deleteNews: function () {
      if(confirm('정말로 삭제하시겠습니까?')){
        let topicList = []
        let checkReward = document.querySelectorAll('.check-topic')
        for (const element of checkReward) {
          if (element.checked) {
            topicList.push(element.value)
          }
        }
        if (topicList.length > 0) {
          const url = '/v1/api/admin/videos-delete'
          this.axios.post(url, topicList)
          .then(res => {
            if (res.data.err === 0) {
              alert('삭제처리가 완료되었습니다.')
              this.selectVideos();
              this.doCancelAll()
            } else {
              alert('삭제처리에 실패했습니다.')
            }
          }).catch(err => {
            if (err.response.data.path === '/login/msg') {
              alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
              this.$router.push('/login')
            } else {
              alert('관리자에게 문의하세요')
            }
          })
        } else {
          alert('삭제할 사람을 선택해주세요.')
        }
      }
    },

    goOtherPage(path){
            let route = this.$router.resolve({path});
            window.open(route.href,"_blank");
        },

    doCancelAll: function () {
      for (const element of document.querySelectorAll('.check-topic')) {
        element.checked = false
      }
    },

    updateTopic: function () {
      let topicList = []
      let checkReward = document.querySelectorAll('.check-topic')
      for (const element of checkReward) {
        if (element.checked) {
          topicList.push(element.value)
        }
      }
      if (topicList.length > 0) {
        const url = '/v1/api/admin/videos-topic'
        this.axios.put(url, topicList)
        .then(res => {
          if (res.data.err === 0) {
            alert('토픽처리가 완료되었습니다.')
            this.selectVideos();
            this.doCancelAll()
          } else {
            alert('토픽처리가 실패했습니다.')
          }
        }).catch(err => {
          if (err.response.data.path === '/login/msg') {
            alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
            this.$router.push('/login')
          } else {
            alert('관리자에게 문의하세요')
          }
        })
      } else {
        alert('토픽이용 처리할 사람을 선택해주세요.')
      }
    },

    doMoveView: function (idx) {
      window.open('/cafe/pop_news_learn_recommend?news_seq=' + idx)
    },

    selectTutors: function () {
      const url = '/v1/api/admin/tutors'
      const params = this.getParams({
        isAll: true
      })
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          this.tutors = res.data.result
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },

    selectVideoAll: function () {
      const url = '/v1/api/admin/videos'
      const params = this.getParams({
        isAll: true
      })
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          this.videos = res.data.result
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },

    selectVideos: function () {
      const url = '/v1/api/admin/videos'
      const params = this.getParams({
        year: this.filter.year,
        month: this.filter.month,
        code: this.filter.code,
        tutor: this.filter.tutor
      })
      localStorage.setItem('reuterContentsParams', JSON.stringify(this.filter))
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          console.log(res)
          this.videos = res.data.result
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    }
  }
}
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";

.is-use {
  background-color: #81F79F;
}

.is-use-text {
  color:green
}

.is-not-use-text {
  color:red
}


</style>



// WEBPACK FOOTER //
// src/pages/videos/videos.vue